<template lang="pug">
pr-wrapper(fs)
  .back.col.col-3.p-4(v-html="$t('press.backToBack')" v-visible="backButton")
  .cdi-osd(:class="{ 'no-action': !hasAction }")
    .cdi-navigation.d-flex(v-nv:scope="'cdi-scope'", @nv-back="close", data-right="cms-actions")
      .cdi-navigation-item(v-nv, v-if="!hasSlides")
      .cdi-navigation-item.surface-bg.border.background.left(v-nv, @nv-enter="change('left')", v-if="hasSlides")
        icon(:icon="'fal chevron-left'")
      .cdi-navigation-item.surface-bg.border.background.play(v-nv, @nv-enter="toggle", v-if="hasSlides")
        icon(:icon="isPlaying ? 'fal pause' : 'fal play'")
      .cdi-navigation-item.surface-bg.border.background.right(v-nv.current, @nv-enter="change('right')", v-if="hasSlides")
        icon(:icon="'fal chevron-right'")
    .cdi-actions(v-if="hasAction")
      actions(@cart="addToCart", :data="content", :data-left="hasSlides ? 'cdi-scope' : false", navigate, @nv-back="close")
</template>

<script>
import actions from "../layouts/actions.vue"
export default {
  name: "cms-detail-image",
  components: { actions },
  props: ["content", "prevRoute"],
  data() {
    return {
      isPlaying: true
    }
  },
  computed: {
    backButton() {
      return __.device.config("cms_back_button_behaviour.cms_back_button_behaviour") === "enable"
    },
    gallery() {
      return this.content?.gallery || []
    },
    hasSlides() {
      return this.gallery.length > 1
    },
    hasAction() {
      return (
        (["appointment", "reservation", "request"].includes(this.content.action_type) && this.content?.endpoint !== "pms") ||
        (["product"].includes(this.content.action_type) && this.content.price)
      )
    }
  },
  async activated() {
    __.platform.background(this.gallery.map(item => item.large))
    _$.nav.sync("cdi-scope")

    if (document.getElementById("cms-actions")?.offsetParent) _$.nav.changeScope("cms-actions")
    else _$.nav.changeScope("cdi-scope")
  },
  methods: {
    close() {
      __.platform.go(this.prevRoute)
    },
    toggle() {
      if (!this.hasSlides) return

      this.isPlaying = !this.isPlaying
      _$.vue.$emit("background", "toggle")
    },
    change(direction) {
      if (!this.hasSlides) return

      if (direction === "right") {
        this.isPlaying = false
        _$.vue.$emit("background", "next")
      } else {
        this.isPlaying = false
        _$.vue.$emit("background", "prev")
      }
    },
    addToCart(payload) {
      __.order.add(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.cdi-osd {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translatex(-50%);
  display: flex;
  align-items: center;

  &.no-action {
    left: auto !important;
    right: 0 !important;
    transform: translateX(0) !important;
  }

  .cdi-navigation {
    .cdi-navigation-item {
      padding: 0.5em 0.75em !important;
      margin-left: -1px;
    }
  }

  .cdi-actions {
    .cms-actions {
      margin-top: 0 !important;
    }
  }
}
</style>
